import { any, shape, string, number, arrayOf, func, bool } from 'prop-types';

export const selectedDepartmentTypes = shape({
  name: string,
  number: string,
  type: string,
  currentRemaining: string,
  futureRemaining: string,
  code: string
});

export const filterTypes = shape({
  key: string,
  values: arrayOf(string)
});

export const filtersTypes = {
  clear: func,
  closeOnOutsideClick: bool,
  count: number,
  filters: arrayOf(filterTypes),
  onChange: func,
  selected: any,
  selectedFacet: bool,
  allSizesAvailable: bool
};

export const unitAllotmentTypes = {
  allotmentAmount: string,
  description: string,
  sourceSystemId: string,
  totalSpend: string,
  unitAttributeName: string,
  unitAttributeValue: string
};
